(function ($) {
  customerServiceFormatterMenuMobileV1 = {
    formatter: $('.cs-formatter-menu-mobile-v1')
  };

  Drupal.behaviors.customerServiceFormatterMenuMobileV1 = {
    get: function (key) {
      return customerServiceFormatterMenuMobileV1[key];
    },

    set: function (key, val) {
      customerServiceFormatterMenuMobileV1[key] = val;
    },

    attach: function (context, settings) {
      var self = this;
      var formatter = self.get('formatter');

      formatter.each(function (i) {
        var thisFormatter = $(this);
      // code goes here...
      });
    }
  };
})(jQuery);
